import { QRCodeSVG } from "qrcode.react";

import { Modal } from "@stellar/design-system";

import AppStoreBadgeSrc from "@/assets/official-app-store-badge.png";
import GooglePlayBadgeSrc from "@/assets/official-playstore-badge-2.png";
import VIAWalletLogoSrc from "@/assets/VIA-wallet-logo.svg";

import "./styles.scss";

interface ModalDownloadWalletProps {
  visible: boolean;
  onClose: () => void;
  appStoreUrl?: string;
  playStoreUrl?: string;
  qrUri?: string;
}

const DEFAULT_APP_STORE_URL = "https://apps.apple.com/id/app/via-wallet/id6479538897";
const DEFAULT_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.solvewithvia.wallet&pcampaignid=web_share";
const DEFAULT_QR_URI = "https://uniqo.de/2st1r2";

export const ModalDownloadWallet: React.FC<ModalDownloadWalletProps> = ({
  visible,
  onClose,
  appStoreUrl = DEFAULT_APP_STORE_URL,
  playStoreUrl = DEFAULT_PLAY_STORE_URL,
  qrUri = DEFAULT_QR_URI,
}) => {
  return (
    <Modal visible={visible} onClose={onClose}>
      <Modal.Heading>
        <div className="ModalDownloadWallet__heading">
          Download
          <img
            src={VIAWalletLogoSrc}
            alt="via-wallet-logo"
            width="30"
            style={{ borderRadius: "5px" }}
          />
          VIA Wallet
        </div>
      </Modal.Heading>
      <Modal.Body>
        <div className="ModalDownloadWallet__body">
          <div className="ModalDownloadWallet__qr" aria-label="QR code to download VIA Wallet">
            <QRCodeSVG
              value={qrUri}
              size={160}
              level="M"
              includeMargin={false}
              imageSettings={{
                src: VIAWalletLogoSrc,
                height: 32,
                width: 32,
                excavate: true,
              }}
            />
          </div>

          <div className="ModalDownloadWallet__badges">
            <a
              className="ModalDownloadWallet__badge"
              href={appStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Download VIA Wallet on the App Store"
            >
              <img
                className="ModalDownloadWallet__badgeImg"
                src={AppStoreBadgeSrc}
                alt="Download on the App Store"
              />
            </a>

            <a
              className="ModalDownloadWallet__badge"
              href={playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get VIA Wallet on Google Play"
            >
              <img
                className="ModalDownloadWallet__badgeImg"
                src={GooglePlayBadgeSrc}
                alt="Get it on Google Play"
              />
            </a>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalDownloadWallet;
